import axios from 'axios';
const axiosInstance = axios.create({
  baseURL: process.env.GATSBY_APP_BACKEND_URL,
});

export const reportData = async (id, key, value) => {
  const backendUser = process.env.GATSBY_APP_BACKEND_USER;
  const backendPass = process.env.GATSBY_APP_BACKEND_PASS;

  const config = {
    auth: {
      username: backendUser,
      password: backendPass,
    },
  };

  axiosInstance
    .put(
      `/teachers/unregistered/seo/${id}`,
      {
        save: {
          key,
          value,
        },
      },
      config
    )
    .then()
    .catch((e) => console.error('error while reporting data', e));
};
